import { GlobalHeaderState, SwgyHeaderKeysList } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/core-ui";

export const isUserLoggedIn = (): boolean => {
    const userId = GlobalHeaderState.getHeader(SwgyHeaderKeysList.userId) || null;
    const tid = GlobalHeaderState.getHeader(SwgyHeaderKeysList.tid) || null;

    return !isEmpty(userId) && !isEmpty(tid);
};
